import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
  width: 100%;
`;

export const HeaderSection = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  padding: 0.25rem 0.5rem; /* reduced padding */
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    fill: #255186;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.2rem; /* was 1.5rem */
  font-weight: 600;
  text-align: center;
  margin: 0.25rem 0; /* optional: reduces vertical space */
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.1rem; /* was 1.2rem */
  color: #255186;
  transition: color 0.2s ease-in;
  margin: 0.25rem 1.5rem; /* was 0.5rem 2rem */

  @media only screen and (max-width: 768px) {
    margin: 1rem 1.5rem; /* was 1.25rem 2rem */
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 18px; /* was 22px */
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #316bb1;
    text-underline-position: under;
    text-decoration: #316bb1 underline;
  }
`;
